function postPasswordlessToApi (that, productEntityId) {
  if (that.$auth?.loggedIn) {
    return that.$axios.post('/private/customer/passwordless', {})
  } else {
    return that.$axios.post('/public/product/passwordless/' + productEntityId, {}, { withCredentials: true })
  }
}

function addAfterLoginAction (that, data, customerId) {
  if (that.$auth?.loggedIn) {
    return that.$axios.post('/private/after/login/action/add', data)
  } else if (customerId) {
    return that.$axios.post('/public/after/login/action/add/' + customerId, data, { withCredentials: true })
  } else {
    return that.$axios.post('/public/after/login/action/add', data, { withCredentials: true })
  }
}

async function addDefaultAfterLoginRedirectActions (that) {
  await addAfterLoginAction(that, {
    method: 'redirect',
    route: {
      name: 'account-messages'
    }
  })
}

async function addRedirectRouteAfterLoginActions (that, route) {
  await addAfterLoginAction(that, {
    method: 'redirect',
    route
  })
}

async function shareLinkWith2ndDevice (that, relPath, productEntityId) {
  await that.$axios.post('/public/product/share-with-owner/' + productEntityId, {
    path: relPath + '?cm24=' + that.$cookies.get('cm24-uuid')

  }, { withCredentials: true })
}

async function getCsrfToken (that) {
  const sessionId = that.$cookies.get('X-Session-Id')
  const { data, status } = await that.$axios.get('/public/auth/csrf-token', {
    withCredentials: true,
    headers: { 'X-Session-Id': sessionId }
  })
  if (status !== 200) {
    console.error('could not get CSRF token', status, data)
    throw new Error('could not get CSRF token')
  }
  return { csrfToken: data.csrfToken, sessionId }
}

const api = {

  postPasswordlessToApi,
  addAfterLoginAction,
  addDefaultAfterLoginRedirectActions,
  addRedirectRouteAfterLoginActions,
  shareLinkWith2ndDevice,
  getCsrfToken

}

export default api
